
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import PersonIcon from '@material-ui/icons/Person';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import MapIcon from '@material-ui/icons/Map';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import { Link } from 'react-router-dom'



const useStyles = makeStyles({
  root: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    justifyContent: 'space-around',
    backgroundColor: 'RGB(99,192,187)',
    height:"8vh",
    display:"flex"
  },
  icon: {
    color: '#E0FFFF'
  }
});

export default function Bottom() {
  const classes = useStyles();
  const [value, setValue] = React.useState('recents');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const cleansStorage = () => {
    sessionStorage.removeItem(`position`)
}

  return (
    <div className="bottom">
      <BottomNavigation onClick={() =>  cleansStorage()} value={value} onChange={handleChange} className={classes.root}>
        <Link to="/mappy"><BottomNavigationAction label="Carte" value="Carte" icon={<MapIcon style={{ fontSize: 30 }} className={classes.icon} />} /></Link>
        <Link to="/addEvent"><BottomNavigationAction label="Evenement" value="Evenement" icon={<AddLocationIcon style={{ fontSize: 30 }} className={classes.icon} />} /></Link>
        <Link to="/allEvents"><BottomNavigationAction label="Photos" value="Photos" icon={<PhotoLibraryIcon style={{ fontSize: 30 }} className={classes.icon} />} /></Link>
  {localStorage.userToken ? <Link to="/monProfil"><BottomNavigationAction label="Login" value="Login" icon={<PersonIcon style={{ fontSize: 30 }} className={classes.icon} />} /></Link> : <Link to="/login"><BottomNavigationAction label="Login" value="Login" icon={<PersonIcon style={{ fontSize: 30 }} className={classes.icon} />} /></Link> }
      </BottomNavigation>
    </div>
  );
}
